export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.7.0',
};
//# sourceMappingURL=buildEnv.js.map